function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1.415L5.572 6.99 0 12.567l1.414 1.415 5.584-5.59 5.587 5.589 1.414-1.415-5.573-5.574 5.573-5.574L12.585.003 6.999 5.59 1.414 0 0 1.415z",
  fill: "#8D919E"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTVRRaUlHaGxhV2RvZEQwaU1UUWlJSFpwWlhkQ2IzZzlJakFnTUNBeE5DQXhOQ0lnWm1sc2JEMGlibTl1WlNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWo0S1BIQmhkR2dnWm1sc2JDMXlkV3hsUFNKbGRtVnViMlJrSWlCamJHbHdMWEoxYkdVOUltVjJaVzV2WkdRaUlHUTlJazB3TGpBd01ERTNNelF5TkNBeExqUXhORGN5VERVdU5UY3hOU0EyTGprNU1EaE1NQzR3TURBeE56TTBORFVnTVRJdU5UWTJPVXd4TGpReE16YzVJREV6TGprNE1UZE1OaTQ1T1RneElEZ3VNemt5TmpOTU1USXVOVGcxSURFekxqazRNRGxNTVRNdU9UazVJREV5TGpVMk5qVk1PQzQwTWpZd01TQTJMams1TWpFeVRERXpMams1T1NBeExqUXhOemMyVERFeUxqVTROU0F3TGpBd016TTNOREl5VERZdU9UazVORElnTlM0MU9UQXpUREV1TkRFek56a2dMVGt1TVRRd05qSmxMVEExVERBdU1EQXdNVGN6TkRJMElERXVOREUwTnpKYUlpQm1hV3hzUFNJak9FUTVNVGxGSWk4K0Nqd3ZjM1puUGdvPSI=";
export { SvgClose as ReactComponent };